import { createServerFn } from '@tanstack/react-start'
import { z } from 'zod'
import { getFromS3, listFromS3 } from '../../lib/s3'
import type { Note, NoteListItem } from './noteSchemas'

export const getNotes = createServerFn({ method: 'GET' })
  .inputValidator(z.object({ currentUser: z.string().optional() }))
  .handler(async (ctx): Promise<NoteListItem[]> => {
    try {
      const keys = await listFromS3('notes/')
      const notes: NoteListItem[] = []
      for (const key of keys) {
        if (key && key.endsWith('.json')) {
          const note: Note = await getFromS3(key)
          // Hide notes with hidden=true unless the current user is Harry
          if (note.hidden && ctx.data.currentUser !== 'Harry') {
            continue
          }
          notes.push({
            id: note.id,
            title: note.title,
            lastEditedBy: note.lastEditedBy ?? '',
            updatedAt: note.updatedAt,
            hidden: note.hidden,
          })
        }
      }
      return notes.sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
    } catch {
      return []
    }
  })
